"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterCredentialsFromObject = void 0;
const maskUpperCaseKeys = ["token", "assertion", "subjectToken", "clientSecret", "clientAssertion", "accessToken", "refreshToken"];
const maskKeys = [...maskUpperCaseKeys, ...maskUpperCaseKeys.map(s => {
  const result = s.replace(/([A-Z])/g, " $1");
  return result.split(" ").join("_").toLowerCase();
})];
const filterCredentialsFromObject = data => Object.fromEntries(Object.entries(data).map(([key, value]) => {
  if (maskKeys.includes(key) && value) {
    return [key, "******"];
  }
  return [key, value];
}));
exports.filterCredentialsFromObject = filterCredentialsFromObject;
//# sourceMappingURL=credentialFilter.js.map